import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dce8e1a8&scoped=true&"
import script from "./storyDetailView.js?vue&type=script&lang=js&"
export * from "./storyDetailView.js?vue&type=script&lang=js&"
import style0 from "./storyDetailView.scss?vue&type=style&index=0&id=dce8e1a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce8e1a8",
  null
  
)

export default component.exports